import { Component, OnInit, Input } from '@angular/core';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { ConfigService, StoreService } from 'app/services';
import { CustomWindow } from 'app/@types';
import { Utils } from 'app/utils';
import { TableLazyLoadEvent } from 'primeng/table';

declare let window: CustomWindow;

@Component({
    selector: 'partner-mart-locations-group-stores',
    templateUrl: './partner-mart-locations-group-stores.component.html',
    styleUrls: [
        './partner-mart-locations-group-stores.component.scss',
        '../../partner-mart-locations-root/partner-mart-locations-root.component.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsGroupStoresComponent implements OnInit {
    public adminUrl: string = window['adminUrl'];

    @Input()
    public groupId: number = 0;

    @Input()
    public groupName: string = '';

    public stores: Array<any> = [];

    public cols: any[] = [
        { field: 'Id', header: 'Store ID', width: '200px' },
        { field: 'Name', header: 'Store Name', width: '200px' },
        { field: 'City', header: 'Store City', width: '200px' },
        { field: 'StatusName', header: 'Store Status', width: '200px' },
        { field: 'XXXXX', header: 'Last Tx', width: '200px', disableSort: true },
        { field: 'XXXXX', header: 'Monthly Rev', width: '200px', disableSort: true },
        { field: 'XXXXX', header: 'Published Status', width: '200px', disableSort: true },
    ];

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public isSpinnerVisible: boolean = true;

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        private storeService: StoreService) {
    }

    ngOnInit(): void {
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort in single sort mode
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        //multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        //filters: Filters object having field as key and filter value, filter matchMode as value
        //globalFilter: Value of the global filter if available

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getStores(skip);
    }

    private getStores(skip: number): void {
        this.isSpinnerVisible = true;

        const dto = {
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            GroupId: this.groupId
        };

        this.storeService.getStoresForGrid(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.stores = data.Stores;

                this.isSpinnerVisible = false;
            });
    }

    public onEditStoreClick(store: any): void {

    }
}
